let el;

try {
    el = document.querySelector('body[data-page="defaultLoginForm"] #mainContainer label[for="login_form_rememberMe"]');
    if (typeof el == "object" && el != null) {
        el.innerHTML = el.innerHTML.replace(/^angemeldet/,"Angemeldet");
    }
} catch (e) {}

document.body.classList.add("js-finished");